import { Component, OnInit, Input } from '@angular/core';
import { TEXT } from '../../../../../../locales/text';

@Component({
    selector: 'message-report-sent-successfully',
    templateUrl: './message-report-sent-successfully.component.html',
    styleUrls: ['./message-report-sent-successfully.component.less']
})
export class MessageReportSentSuccessfullyComponent implements OnInit {
    @Input() nameReport = '';
    @Input() statusReport = '';

    TEXT = TEXT;

    constructor() {
    }

    ngOnInit(): void {
    }

}
